import React, { Component } from "react";
import { StyleSheet, css } from "aphrodite";
// import { Jumbotron } from 'react-bootstrap';
import firebase from "firebase";
// import { Grid,Row,Col } from 'react-bootstrap';
import { connect } from "react-redux";
import { GetPromo } from "../../redux/actions/getPromo";

import Snuggle from "react-snuggle";

import Card from "../card";
import Map from "../map";
class Content extends Component {
  componentWillMount() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        var user = firebase.auth().currentUser;
        user.providerData.forEach(profile => {
          this.props.GetPromo(profile.email);
        });
      }
    });
  }
  render() {
    return (
      <div className="row">
        <div className="col-md-8 col-sm-12 display-table-cell v-align nopadding">
          <div className={css(styles.promocoes)}>
            <center>
              <h4>Promoções Cadastradas</h4>
            </center>
            <div className={css(styles.content)}>
              <Snuggle rowGap="10px">
                {this.props.promos.map(item => {
                  return (
                    <Card
                      title={item.nome}
                      data={item.dataPost}
                      clicks={5}
                      text={item.conteudo}
                      img={item.img}
                      active={item.valido}
                      key={item.id}
                      id={item.id}
                      promocao={item.promocao}
                    />
                  );
                })}
              </Snuggle>
            </div>
          </div>
        </div>
        <div className="col-md-4 col-sm-12 display-table-cell v-align nopadding">
          <div className={css(styles.map)}>
            <center>
              <h4>Usuários na sua Localidade</h4>
            </center>
            <div className={css(styles.mapContainer)}>
              <div className={css(styles.spacer)} />
              <Map />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  promocoes: {
    background: "#eff0f1",
    padding: "15px",
    paddingTop: "1px",
    borderRadius: "4px"
  },
  container: {
    display: "flex",
    flexDirection: "row",
    padding: "20px"
  },
  list: {
    width: "75%",
    display: "flex",
    flexDirection: "column"
  },
  map: {
    width: "100%",
    "@media (max-width: 991px)": {
      marginTop: "20px"
    }
  },
  mapContainer: {
    width: "100%",
    height: "260px"
  }
});

const mapStateToProps = state => {
  return {
    promos: state.promos.ListPromos,
    user: state.user.user
  };
};
export default connect(
  mapStateToProps,
  { GetPromo }
)(Content);



// WEBPACK FOOTER //
// ./src/assets/content/index.js